import type { Handicap } from '@ps/isp-web-services-types';
import { RunnerResultType } from '@ps/isp-web-services-types';

export const getHandicapSelectionValue = ({
  handicap,
  runnerResultType
}: {
  handicap: Handicap | undefined;
  runnerResultType: RunnerResultType | undefined;
}) => {
  if (!handicap || handicap === 0) {
    return undefined;
  }

  if (runnerResultType === RunnerResultType.OVER) {
    return `> ${handicap}`;
  }

  if (runnerResultType === RunnerResultType.UNDER) {
    return `< ${handicap}`;
  }

  return Math.sign(handicap) === 1 ? `+${handicap}` : String(handicap);
};
